import Content, {IContent} from "@/model/Content/Content"

interface IFeeContent extends IContent {
    getName(): string
}

class FeeContent extends Content implements IFeeContent {
    private name: string

    constructor(
        name: string
    ) {
        super()
        this.name = name
    }

    public getName(): string {
        return this.name
    }

}

export default FeeContent